import React, { FC, useContext } from "react";
import { LISQuestions } from "../../components/LISQuestions";
import { AppPage, LoggedOutFooter } from "../../components";
import { useTranslate, useYearInTitle } from "../../helpers";
import { AppStore } from "../../app/store";
import { useHistory, useLocation } from "react-router";
import { CoverageType } from "../QuestionRoutingPage/types";
import { handleContinuingFromLISQuestions } from "../../helpers";

export interface LISQuestionsPageProps {
  coverageType?: CoverageType;
  isFromSummaryPage?: boolean;
}

export const LISQuestionsPage: FC<LISQuestionsPageProps> = ({
  coverageType,
  isFromSummaryPage = false,
}) => {
  const {
    state: { year, county },
    state,
    dispatch,
  } = useContext(AppStore.AppContext);
  const t = useTranslate();
  const history = useHistory();
  const location = useLocation();
  const heading = t("extra_help_page.banner.title");
  const title = useYearInTitle(heading, year);

  return (
    <AppPage heading={heading} title={title}>
      <div className="ds-u-margin-bottom--5 PlanPreferencePage">
        <LISQuestions
          nextPage={() =>
            handleContinuingFromLISQuestions({
              state,
              dispatch,
              history,
              location,
              coverageType,
              county,
              isFromSummaryPage,
            })
          }
        />
      </div>
      <LoggedOutFooter />
    </AppPage>
  );
};
